import { useContext } from 'react';
import { StoreContext } from './store-context';

export function useStoreContext() {
  const storeContext = useContext(StoreContext);
  return storeContext;
}
